// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstWorkshop {
constructor({
        id = null,
        code = '',
        parentId = '',
        name = '',
        machineType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.parentId = parentId;
    this.name = name;
    this.machineType = machineType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstWorkshop();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineType',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.machineType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstWorkshop.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    codeFilter : "",
    parentIdFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    nameFilter : "",
    machineTypeFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.mst.sithMesMstWorkshop.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.sith.mst.sithMesMstWorkshop.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstWorkshop'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstWorkshop.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineTypeFilter',
        label: 'label.sith.mst.sithMesMstWorkshop.filter.machineType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.mst.sithMesMstWorkshop.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstWorkshop.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentId',
        label: 'label.sith.mst.sithMesMstWorkshop.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstWorkshop'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstWorkshop.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineType',
        label: 'label.sith.mst.sithMesMstWorkshop.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstWorkshop.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstWorkshop, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
